"use strict";

exports.__esModule = true;
exports.unitDefinitions = exports.UNIT_SECOND = exports.UNIT_PERCENT = exports.UNIT_MILLISECOND = exports.UNIT_MILLIMETER_3D = exports.UNIT_FRACTIONAL_PERCENT = void 0;
var UNIT_MILLISECOND = exports.UNIT_MILLISECOND = "MILLISECOND";
var UNIT_SECOND = exports.UNIT_SECOND = "SECOND";
var UNIT_MILLIMETER_3D = exports.UNIT_MILLIMETER_3D = "MILLIMETER_3D";
var UNIT_PERCENT = exports.UNIT_PERCENT = "PERCENT";
var UNIT_FRACTIONAL_PERCENT = exports.UNIT_FRACTIONAL_PERCENT = "FRACTIONAL_PERCENT";
var unitDefinitions = exports.unitDefinitions = [{
  type: "number",
  name: "AMPERE",
  label: "Amperes",
  symbol: "A",
  description: "Amps"
}, {
  type: "number",
  name: "CELSIUS",
  label: "Celsius",
  symbol: "°C",
  description: "Degrees Celsius"
}, {
  type: "number",
  name: "COUNT",
  label: "Count",
  symbol: "",
  description: "A counted event"
}, {
  type: "number",
  name: "DECIBEL",
  label: "Decibels",
  symbol: "dB",
  description: "Sound Level"
}, {
  type: "number",
  name: "DEGREE",
  label: "Degrees",
  symbol: "°",
  description: "Angle in degrees"
}, {
  type: "number",
  name: "DEGREE/SECOND",
  label: "Degrees / Second",
  symbol: "°/s",
  description: "Angular degrees per second"
}, {
  type: "number",
  name: "DEGREE/SECOND^2",
  label: "Degrees / Second ^2",
  symbol: "°/s²",
  description: "Angular acceleration in degrees per second squared"
}, {
  type: "number",
  name: "HERTZ",
  label: "Hertz",
  symbol: "Hz",
  description: "Frequency measured in cycles per second"
}, {
  type: "number",
  name: "JOULE",
  label: "Joules",
  symbol: "J",
  description: "A measurement of energy"
}, {
  type: "number",
  name: "KILOGRAM",
  label: "Kilograms",
  symbol: "Kg",
  description: "Kilograms"
}, {
  type: "number",
  name: "LITER",
  label: "Liters",
  symbol: "L",
  description: "Liters"
}, {
  type: "number",
  name: "LITER/SECOND",
  label: "Liters / Second",
  symbol: "L/s",
  description: "Liters per second"
}, {
  type: "number",
  name: "MICRO_RADIAN",
  label: "Micro Radians",
  symbol: "µrad",
  description: "Measurement of Tilt"
}, {
  type: "number",
  name: "MILLIMETER",
  label: "Millimeters",
  symbol: "mm",
  description: "Millimeters"
}, {
  type: "number",
  name: "MILLIMETER/SECOND",
  label: "Millimeters / Second",
  symbol: "mm/s",
  description: "Millimeters per second"
}, {
  type: "number",
  name: "MILLIMETER/SECOND^2",
  label: "Millimeters / Second ^2",
  symbol: "mm/s²",
  description: "Acceleration in millimeters per second squared"
}, {
  type: "point",
  name: "MILLIMETER_3D",
  label: "Millimeter 3D",
  symbol: "mm-3d",
  description: "A point in space identified by X, Y, and Z positions and represented by a space-delimited set of numbers each expressed in millimeters."
}, {
  type: "number",
  name: "NEWTON",
  label: "Newtons",
  symbol: "N",
  description: "Force in Newtons"
}, {
  type: "number",
  name: "NEWTON_METER",
  label: "Newton Meters",
  symbol: "N m",
  description: "Torque, a unit for force times distance."
}, {
  type: "number",
  name: "OHM",
  label: "Ohms",
  symbol: "Ω",
  description: "Measure of Electrical Resistance"
}, {
  type: "number",
  name: "PASCAL",
  label: "Pascals",
  symbol: "Pa",
  description: "Pressure in Newtons per square meter"
}, {
  type: "number",
  name: "PASCAL_SECOND",
  label: "Pascal Seconds",
  symbol: "Pa-s",
  description: "Measurement of Viscosity"
}, {
  type: "number",
  name: "PERCENT",
  label: "Percent",
  symbol: "%",
  description: "Percentage"
}, {
  type: "number",
  name: "FRACTIONAL_PERCENT",
  label: "Percent",
  symbol: "%",
  description: "Fractional percentage"
}, {
  type: "number",
  name: "PH",
  label: "PH",
  symbol: "PH",
  description: "A measure of the acidity or alkalinity of a solution"
}, {
  type: "number",
  name: "REVOLUTION/MINUTE",
  label: "RPM",
  symbol: "rpm",
  description: "Revolutions per minute"
}, {
  type: "number",
  name: "SECOND",
  label: "Seconds",
  symbol: "s",
  description: "A measurement of time."
}, {
  type: "number",
  name: "SIEMENS/METER",
  label: "Siemens / Meter",
  symbol: "S/m",
  description: "A measurement of Electrical Conductivity"
}, {
  type: "number",
  name: "VOLT",
  label: "Volts",
  symbol: "V",
  description: "Volts"
}, {
  type: "number",
  name: "VOLT_AMPERE",
  label: "Volt-Amperes",
  symbol: "VA",
  description: "Volt-Ampere (VA)"
}, {
  type: "number",
  name: "VOLT_AMPERE_REACTIVE",
  label: "Volt-Ampere Reactive",
  symbol: "VAR",
  description: "Volt-Ampere Reactive (VAR)"
}, {
  type: "number",
  name: "WATT",
  label: "Watts",
  symbol: "W",
  description: "Watts"
}, {
  type: "number",
  name: "WATT_SECOND",
  label: "Watt Seconds",
  symbol: "W-s",
  description: "Measurement of electrical energy, equal to one Joule"
}, {
  type: "date",
  name: "DATETIME",
  label: "Date / Time",
  symbol: "",
  description: "An ISO formatted Date /Time."
}, {
  type: "number",
  name: "MILLISECOND",
  label: "Milliseconds",
  symbol: "ms",
  description: "A measurement of time."
}, {
  type: "string",
  name: "OTHER",
  label: "Other",
  symbol: "",
  description: "Unknown Units."
}];